import React, { Component } from 'react'
import g from 'glamorous'

class MatchDetail extends Component {
    render () {
        const { timeTxt, dateTxt, stadiumTxt, altTxt } = this.props
        return (<g.Div className="detail-match">
                    <g.Div className="vs">VS</g.Div>
                    <g.Div className="time">{timeTxt}</g.Div>
                    <g.Div className="date">{dateTxt}</g.Div>
                    <g.Div className="stadium">{stadiumTxt}</g.Div>
                    <g.Div className="asterik">{altTxt}</g.Div>
                </g.Div>)
    }
}

export default MatchDetail


// WEBPACK FOOTER //
// ./src/components/calendar/match-detail-fragm.js